import { useEffect, useState } from 'react';
import { RestaurantTable } from '../types';
import api from '../../../../app/api/api';
import { AxiosError } from 'axios';

export const useTableData = (restaurantId: string, tableId?: string) => {
  const [table, setTable] = useState<RestaurantTable | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTable = async () => {
      if (!tableId) return;

      setLoading(true);
      try {
        const data = await api.RestaurantTable.details(restaurantId, tableId);
        setTable(data);
        setError(null);
      } catch (error: unknown) {
        if (error instanceof AxiosError) {
          setError(error.response?.data?.title || 'Failed to load table');
        } else {
          setError('Failed to load table');
        }
        setTable(null);
      } finally {
        setLoading(false);
      }
    };

    fetchTable();
  }, [restaurantId, tableId]);

  return { table, loading, error };
};
